import React from 'react';
import {Helmet} from 'react-helmet-async';
import Banner from '../Banner/Banner';
import Footer from '../Footer/Footer';
import Hero from './Hero';
import SubNav from './SubNav';
import Section from './Section';
import sections from './content';
import './Information.css';

function Index() {
    return (
        <div>
            <Helmet defer={false}>
                <title>Common Foot Conditions Explained | Love Your Feet Podiatry</title>
                <meta
                    name="description"
                    content="Learn about corns, calluses, warts, cracked heels, ingrown and fungal nails, plantar fasciitis and diabetic foot care."
                />
                <link rel="canonical" href="https://loveyourfeet.co.nz/information"/>
            </Helmet>
            <Banner/>
            <Hero/>
            <SubNav/>
            {sections.map((section, index) => (
                <Section key={section.id} section={section} reverse={index % 2 === 1}/>
            ))}
            <Footer/>
        </div>
    );
}

export default Index;
